module.exports = __webpack_public_path__ + "img/logo_red.b4ef1de3.png";